import React from 'react';
import PropTypes from 'prop-types';
import Form from 'antd/lib/form';
import Input from 'antd/lib/input';
import Button from 'antd/lib/button';

import { Label } from 'components';

import { SubmitButtonWrapper } from './style';

const CreateMapForm = (props) => {
  const {
    form: {
      getFieldDecorator,
      validateFields,
    },
    createEditPage,
    type,
  } = props;

  const decorateInput = (name, autoFocus, options = {}) => getFieldDecorator(name, options)(
    <Input autoFocus={autoFocus} size="large" />,
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    validateFields((error, values) => {
      if (error) {
        return;
      }

      createEditPage(values);
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Label colon={false} label="Name">
        {decorateInput('name', true, {
          rules: [{
            required: true,
            message: `Enter a ${type.toLowerCase()} name`,
          }],
        })}
      </Label>
      <Label colon={false} label="Description">
        {decorateInput('description')}
      </Label>
      <SubmitButtonWrapper>
        <Button
          id={`create-${type.toLowerCase()}`}
          type="primary"
          htmlType="submit"
        >
          {`Create ${type}`}
        </Button>
      </SubmitButtonWrapper>
    </Form>
  );
};

CreateMapForm.propTypes = {
  form: PropTypes.object.isRequired,
  createEditPage: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

const MapForm = React.memo(
  Form.create({ name: 'mapForm' })(
    CreateMapForm,
  ),
);

export default MapForm;
